import styled from 'styled-components';

export const Text = styled.div`
  font-size: 16px;
  line-height: 19px;
  color: #3d3f43;
  background-color: transparent;
  min-height: 16px;
`;
